export const StorageKeys = {
    jwtToken: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=jT',
    idToken: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=iT',
    refreshToken: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=rT',
    User: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=U',
    MPIDList: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=MPIDL',
    MPID: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=MPID',
    SOD_File: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=SODF',
    Nasdaqlisted_File: 'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=NDLF',
    OTCList_File:'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=OTCLF',
    OtherListed_File:'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=OLF',
    LastExecutionfileDate:'U2FsdGVkX1+0mYdYsi9rb59WYFow2H3CUvl3FyLFZPU=LEFD',
};